import React from 'react';

import { AGENT_DETAIL_FIELD_LABELS } from 'types';

import { SummaryRow } from '../../Summary/SummaryRow';
import { useAuth } from '../../../hooks/useAuth';
import { formatAgentCompanyName } from '../../pages/dashboard/info/fieldData';

interface Props {
  displayName: string;
  importAgentName?: string;
  agentFamilyName: string;
  agentGivenName: string;
  branchAddressLine1: string;
  branchAddressLine2: string;
  branchAddressLine3: string;
  branchCity: string;
  branchCountry: string;
  branchPostcode: string;
}

export default function AgentDetailsSummary(props: Props): React.ReactElement {
  const { isAgent } = useAuth();
  const agentCompanyName = formatAgentCompanyName(props.displayName, props.importAgentName);
  return (
    <>
      {!isAgent && <SummaryRow label="Agent Company Name" value={agentCompanyName} />}
      <SummaryRow
        label={AGENT_DETAIL_FIELD_LABELS.agentFamilyName}
        value={props.agentFamilyName || '<no data provided>'}
      />
      <SummaryRow
        label={AGENT_DETAIL_FIELD_LABELS.agentGivenName}
        value={props.agentGivenName || '<no data provided>'}
      />
      <SummaryRow label="Branch Address Line 1" value={props.branchAddressLine1 || '<no data provided>'} />
      <SummaryRow label="Branch Address Line 2" value={props.branchAddressLine2 || '<no data provided>'} />
      <SummaryRow label="Branch Address Line 3" value={props.branchAddressLine3 || '<no data provided>'} />
      <SummaryRow label="Branch City" value={props.branchCity || '<no data provided>'} />
      <SummaryRow label="Branch Country" value={props.branchCountry || '<no data provided>'} />
      <SummaryRow label="Branch Postcode" value={props.branchPostcode || '<no data provided>'} />
    </>
  );
}
